import { datas } from "./Data";
import { Link } from "react-router-dom";
import GridAnimation from "../GridAnimation/Grid";

import TwitterIcon from "@mui/icons-material/Twitter";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import YouTubeIcon from "@mui/icons-material/YouTube";
import InstagramIcon from "@mui/icons-material/Instagram";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import LocationOnIcon from "@mui/icons-material/LocationOn";

import logo from "../../Assets/Logo/lipana.png";
import { Button } from "@mui/material";

const Footer = () => {
  const date = new Date();
  const year = date.getFullYear();

  return (
    <footer className="relative px-5 pt-10 pb-8 xl:px-0 text-white bg-[#010f24] h-max overflow-hidden">
      <div className="absolute left-0 top-0 h-full w-full">
        <GridAnimation />
      </div>
      <div className="mx-auto max-w-6xl h-full flex flex-col justify-between space-y-10 md:space-y-0 md:flex-row md:flex-wrap lg:flex-row">
        <div className="space-y-5  md:w-1/2 lg:w-max">
          <div className="space-y-3 lg:w-max">
            <Link to="/">
              <img src={logo} alt="logo" className="h-8" />
            </Link>

            <h3 className="opacity-[0.9] text-base md:text-[14px]">
              Payments for the next generation <br />
              of internet entrepreneurs
            </h3>
          </div>

          {datas
            .filter((data) => data.name === "contact us")
            .map((item, i) => (
              <div key={i} className="">
                <h2 className="text-lg font-semibold">
                  {item.name.charAt(0).toUpperCase() + item.name.slice(1)}
                </h2>
                <div className="flex flex-row items-start gap-2 mt-3">
                  <LocationOnIcon />
                  <p className="text-[12px] md:w-1/2">{item.location}</p>
                </div>
                <div className="flex flex-col space-y-5 mt-5">
                  {item.items.map((contact, i) => (
                    <a
                      href={
                        item.items.indexOf(contact) === 0
                          ? "maito:support@lipana.app"
                          : `tel:${contact.value}`
                      }
                      key={i}
                      className="flex flex-row items-center gap-2 opacity-[0.9] text-[14px]"
                    >
                      {item.items.indexOf(contact) === 0 ? (
                        <MailOutlineIcon />
                      ) : (
                        <LocalPhoneIcon />
                      )}
                      {contact.value}
                    </a>
                  ))}
                </div>

                <div className="space-y-3 mt-5 lg:mt-10">
                  <h2 className="text-lg font-semibold">We are social</h2>
                  <div className="flex flex-row items-center text-2xl space-x-3 lg:text-3xl">
                    <Link to="https://twitter.com/LipanaApp" className="p-0 h-6 w-6 flex flex-row items-center justify-center">
                      <Button className="!text-white !m-0 !p-0 !text-3xl">
                        <TwitterIcon />
                      </Button>
                    </Link>
                    <Link to="https://www.youtube.com/channel/UCqnsnq62IuiIIN7eO79_ZZA" className="p-0 h-6 w-6 flex flex-row items-center justify-center">
                      <Button className="!text-white">
                        <YouTubeIcon />
                      </Button>
                    </Link>
                    <Link to="https://www.instagram.com/lipanaapp/" className="p-0 h-6 w-6 flex flex-row items-center justify-center">
                      <Button className="!text-white !m-0 !p-0 !text-3xl">
                        <InstagramIcon />
                      </Button>
                    </Link>
                    <Link to="https://wa.me/254791814113" className="p-0 h-6 w-6 flex flex-row items-center justify-center">
                      <Button className="!text-white !m-0 !p-0 !text-3xl">
                        <WhatsAppIcon />
                      </Button>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
        </div>
        <div className="md:w-1/2 lg:w-max">
          {datas
            .filter((data) => data.name === "products")
            .map((item, i) => (
              <div key={i} className="space-y-5">
                <h2 className="text-lg font-semibold">
                  {item.name.charAt(0).toUpperCase() + item.name.slice(1)}
                </h2>
                <div className="flex flex-col space-y-5">
                  {item.items.map((link, i) => (
                    <Link
                      to="/"
                      className="opacity-[0.9] text-[14px] hover:text-[#FF9B00]"
                      key={i}
                    >
                      {link.value}
                    </Link>
                  ))}
                </div>
              </div>
            ))}
        </div>

        <div className="space-y-10 md:w-1/2 md:!mt-8 lg:w-max lg:!mt-0">
          {datas
            .filter((data) => data.name === "company")
            .map((item, i) => (
              <div key={i} className="space-y-5">
                <h2 className="text-lg font-semibold">
                  {item.name.charAt(0).toUpperCase() + item.name.slice(1)}
                </h2>
                <div className="flex flex-col space-y-5">
                  {item.items.map((link, i) => (
                    <Link
                      to="/"
                      className="opacity-[0.9] text-[14px] hover:text-[#FF9B00]"
                      key={i}
                    >
                      {link.value}
                    </Link>
                  ))}
                </div>
              </div>
            ))}
        </div>

        <div className="space-y-10 md:w-1/2 lg:w-max">
          {datas
            .filter((data) => data.name === "resources")
            .map((item, i) => (
              <div key={i} className="space-y-5">
                <h2 className="text-lg font-semibold">
                  {item.name.charAt(0).toUpperCase() + item.name.slice(1)}
                </h2>
                <div className="flex flex-col space-y-5">
                  {item.items.map((link, i) => (
                    <Link
                      to="/"
                      className="opacity-[0.9] text-[14px] hover:text-[#FF9B00]"
                      key={i}
                    >
                      {link.value}
                    </Link>
                  ))}
                </div>
              </div>
            ))}
        </div>

        <div className="space-y-5 !mt-8 lg:!mt-0">
          {datas
            .filter((data) => data.name === "legal")
            .map((item, i) => (
              <div key={i} className="space-y-5">
                <h2 className="text-lg font-semibold">
                  {item.name.charAt(0).toUpperCase() + item.name.slice(1)}
                </h2>
                <div className="flex flex-col space-y-5">
                  {item.items.map((link, i) => (
                    <Link
                      to="/"
                      className="opacity-[0.9] text-[14px] hover:text-[#FF9B00]"
                      key={i}
                    >
                      {link.value}
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          <div>
            <h2 className="text-lg font-semibold mb-3">Projects</h2>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.aircart.app/"
              className="opacity-[0.9] text-[14px] hover:text-[#FF9B00]"
            >
              aircart
            </a>
          </div>
        </div>
      </div>
      <p className="text-center mt-16 text-[12px]">
        &copy;Lipana Technologies, Inc {year}. All Rights Reserved
      </p>
    </footer>
  );
};

export default Footer;
